export default "__VITE_PUBLIC_ASSET__83ac5e82__"